import { contactFormImage } from 'assets/images';
import React, { Component } from "react";

class ContactTwo extends Component{
    constructor(props){
        super(props);
        this.state = {
            rnName: '',
            rnEmail: '',
            rnSubject: '',
            rnMessage: '',
        };
    }

    handleSuccess = (res) => {
        if (res.status === 200) {
            this.setState({
                rnName: '',
                rnEmail: '',
                rnSubject: '',
                rnMessage: '',
            })
            alert("Success!")
        } else  {
            alert("Error! Try again.")
        }

    }

    handleSubmit = e => {
        fetch("https://api.emailjs.com/api/v1.0/email/send", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                service_id: 'default_service',
                template_id: process.env.REACT_APP_IC_MAILJS_TEMPLATE,
                user_id: process.env.REACT_APP_IC_MAILJS_USER,
                template_params: {
                    'from_name': this.state.rnName,
                    'reply_to': this.state.rnEmail,
                    'to_name': 'Infinity Comics',
                    'message': this.state.rnMessage,
                    'subject': this.state.rnSubject
                }
            })
        })
          .then((res) => this.handleSuccess(res))
          .catch(error => alert(error));

        e.preventDefault();
    };

    render(){
        return(
            <div id="contact" className="contact-form--1">
                <div className="container">
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--50">
                                <h2 className="title">Contact Us.</h2>
                                <p className="description">Get in touch with us to discuss further details about any query or concern you may have.</p>
                            </div>
                            <div className="form-wrapper">
                                <form data-netlify="true" onSubmit={this.handleSubmit}>
                                    <label htmlFor="item01">
                                        <input
                                            type="text"
                                            name="name"
                                            id="item01"
                                            value={this.state.rnName}
                                            onChange={(e)=>{this.setState({rnName: e.target.value});}}
                                            placeholder="Your Name *"
                                        />
                                    </label>

                                    <label htmlFor="item02">
                                        <input
                                            type="text"
                                            name="email"
                                            id="item02"
                                            value={this.state.rnEmail}
                                            onChange={(e)=>{this.setState({rnEmail: e.target.value});}}
                                            placeholder="Your email *"
                                        />
                                    </label>

                                    <label htmlFor="item03">
                                        <input
                                            type="text"
                                            name="subject"
                                            id="item03"
                                            value={this.state.rnSubject}
                                            onChange={(e)=>{this.setState({rnSubject: e.target.value});}}
                                            placeholder="Write a Subject"
                                        />
                                    </label>
                                    <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label>
                                    <button className="rn-button-style--2 btn-solid" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">Submit</button>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src={contactFormImage} alt="infinitycomics"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactTwo;
